import { Component, computed, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { TrophiesRepository } from '@app/shared/state/trophies/trophies.repository';
import { UserTrophies } from '@app/home/trophies/trophies.model';
import { TrophiesService } from '@app/home/trophies/trophies.service';

import { User } from '@shared/models/user.model';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { HallItemComponent } from './hall-item/hall-item.component';
import { SpriteManagerService } from '@app/shared/services/sprite-manager.service';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-recurring-hall',
  templateUrl: './recurring-hall.component.html',
  styleUrls: ['./recurring-hall.component.scss'],
  standalone: true,
  imports: [HallItemComponent],
})
export class RecurringHallComponent implements OnInit {
  private spriteManager = inject(SpriteManagerService);
  private trophiesRepo = inject(TrophiesRepository);
  private userRepo = inject(UserRepository);
  private trophiesService = inject(TrophiesService);

  user = input.required<User>();
  hallDisabled = output<boolean>();

  trophies = signal<UserTrophies[]>([]);

  trophyFlagImage = computed(() =>
    this.spriteManager.getImage('/images/home/trophies-modal/ranking/ranking-blocked.webp')
  );

  trophyPlatformImage = computed(() =>
    this.spriteManager.getImage('/images/home/trophies-modal/ranking/ranking-updating.png')
  );

  rows = computed(() => [this.trophies().slice(0, 5), this.trophies().slice(5)]);

  ngOnInit(): void {
    if (!this.user() || this.user().id === this.userRepo.getUser().id) {
      this.trophies.set(this.trophiesRepo.getTrophies());
    } else {
      this.trophiesService.getUserTrophyDisplay(this.user().id).subscribe((trophies) => {
        this.trophies.set(trophies);
      });
    }
  }

  setTrophiesActive(isActive: boolean) {
    this.hallDisabled.emit(!isActive);
  }
}
